import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/img/icon/user.svg'
import _imports_1 from '../../assets/img/icon/file2.svg'
import _imports_2 from '../../assets/img/icon/clock.svg'
import _imports_3 from '../../assets/img/icon/star.svg'
import _imports_4 from '../../assets/img/icon/web.svg'


const _hoisted_1 = { class: "single-course-sidebar" }
const _hoisted_2 = { class: "course-widget" }
const _hoisted_3 = { class: "sidebar-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "/contact",
  class: "default-btn course-btn"
}, "Hemen Kaydol", -1)
const _hoisted_5 = { class: "courses-details" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "icon"
  }),
  /*#__PURE__*/_createTextVNode(" Eğitmen ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "icon"
  }),
  /*#__PURE__*/_createTextVNode(" Ders Sayısı/Oturum ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "icon"
  }),
  /*#__PURE__*/_createTextVNode(" Süre ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "icon"
  }),
  /*#__PURE__*/_createTextVNode(" Seviye ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: "icon"
  }),
  /*#__PURE__*/_createTextVNode(" Diller ")
], -1)
const _hoisted_11 = {
  key: 0,
  class: "popup-video"
}
const _hoisted_12 = { class: "d-table" }
const _hoisted_13 = { class: "d-table-cell" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "popup-overlay-close-line" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "popup-overlay-close-line" }, null, -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "play-video" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://www.youtube.com/embed/PWvPbGWVRrU",
    allowfullscreen: ""
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.course.price) + " ₺", 1),
          _hoisted_4,
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _hoisted_6,
              _createElementVNode("p", null, _toDisplayString(_ctx.course.instructor.name), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_7,
              _createElementVNode("p", null, _toDisplayString(_ctx.course.lessons), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_8,
              _createElementVNode("p", null, _toDisplayString(_ctx.course.duration), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_9,
              _createElementVNode("p", null, _toDisplayString(_ctx.course.level), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_10,
              _createElementVNode("p", null, _toDisplayString(_ctx.course.language), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.isPopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", {
                class: "popup-overlay-close",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePopup && _ctx.togglePopup(...args)))
              }, _hoisted_16),
              _hoisted_17
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}